export { default as DesktopViewSection } from "./DesktopViewSection";
export { default as FaqSection } from "./FaqSection";
export { default as FooterSection } from "./FooterSection";
export { default as InstagramFeedSection } from "./InstagramFeedSection";
export { default as MainContentSection } from "./MainContentSection";
export { default as OverlapGroupSection } from "./OverlapGroupSection";
export { default as OverlapSection } from "./OverlapSection";
export { default as TestimonialsSection } from "./TestimonialsSection";
export { default as TravelPackagesSection } from "./TravelPackagesSection";
export { default as HeroSection } from "./HeroSection";
export { default as SegmentsSection } from "./SegmentsSection";
export { default as BlogPost } from "./BlogPost";
export { default as BlogTitleSection } from "./BlogTitleSection";
